export default "__VITE_ASSET__BaWaGMcb__"